export const systemTenants = [
  "provider tenant",
  "test tenant",
  "synthetics tenant",
  "system tenant",
];
